<div class="flex flex-col ml-72 mr-72 pb-20 settings-container">
  <div class="flex flex-row justify-between top-header mb-12 mt-12">
    <h2 class="mat-headline-5 mt-20  mb-0">{{'LEFT_SIDE_NAV.SETTINGS' | transloco}}</h2>
  </div>
  <mat-divider class="mb-16 neutral-2"></mat-divider>
  <div class="items-center mb-30">

    <div class="flex flex-nowrap items-start">
      <div class="mat-headline-5 fs-16 mb-0 mr-24">
        <div class="pl-16 pr-80 pt-16 pb-16 noti-bg">{{'NOTIFICATION.NOTIFICATIONS' | transloco}}</div>
      </div>

      <div class="flex flex-col w-100-percent">
        <div class="flex justify-between items-center mb-16">
          <div class="flex flex-col">
            <div class="mat-headline-6 mb-4 fw-600">{{'TENANT_LIST.BIO_TENANT_DETAILS' | transloco}}</div>
            <div class="mat-small fw-400 sub-header">{{'TENANT_LIST.SUB_BIO_TENANT_DETAILS' | transloco}}</div>
          </div>
          <div class="flex flex-row">
            <button class="flex items-center cancel-btn action-btn pl-16 pr-16 pt-8 pb-8 mr-16" *ngIf="!isEdit" (click)="cancel()">
              {{ 'BUTTONS.CANCEL' | transloco }}
            </button>
            <div *ngIf="permissionsMap[PermissionKeys.TENANT_UPDATE]">
              <button *ngIf="isEdit" class="flex items-center mossgreen action-btn primary-fg pl-16 pr-16 pt-8 pb-8"
                (click)="editEmail()">
                <div class="flex items-center">
                  <mat-icon svgIcon="edit" class="mr-8 ml-2 icon-sm"></mat-icon>
                  <span class="mat-subtitle-2 fw-700">{{ 'BUTTONS.EDIT' | transloco }}</span>
                </div>
              </button>
            </div>
            <button class="flex items-center mossgreen action-btn primary-fg pl-16 pr-16 pt-8 pb-8" *ngIf="!isEdit" (click)="save()"
              [ngClass]="{'disabled': (invalidEmail && invalidEmail?.length !== 0 )}">
              <span>{{ 'BUTTONS.SAVE' | transloco }}</span>
            </button>
          </div>
        </div>

        <mat-card>
          <form [formGroup]="tenantForm">

            <ng-container *ngIf="initialLoader; else dataLoaded">
              <div *ngFor="let item of [1,2]" class="w-100-percent">
                <div class="flex flex-row pt-20 pl-20 pr-16 pb-8">
                  <ng-container *ngFor="let item of [1,2,3,4,5]">
                    <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-template #dataLoaded>
              <mat-form-field class="example-chip-list" *ngIf="!isEdit">

                <mat-chip-grid #chipGrid aria-label="Email selection" class="white-bg">
                  <mat-chip-row *ngFor="let email of emailList" (removed)="!isEdit ? remove(email): null"
                    [editable]="true" (edited)="!isEdit ? edit(email, $event): null"
                    [aria-description]="'press enter to edit ' + email"
                    [ngClass]="{'invalid-email': !isValidEmail(email)}" class="email-ids ml-16 mt-8 mb-8 email-label fw-500 mat-body-1">
                    {{email}}
                    <button matChipRemove [attr.aria-label]="'remove ' + email" *ngIf="!isEdit" class="mb-4">
                      <mat-icon svgIcon="close"></mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input placeholder="{{'TENANT_LIST.EMAIL_ADDRESS' | transloco}}" [matChipInputFor]="chipGrid"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="add($event)" formControlName="notificationEmails" class="no-border mt-12" />
              </mat-form-field>


              <mat-chip-set aria-label="Email selection" class="white-bg mt-8 mb-8 mr-16 ml-8" *ngIf="isEdit">
                <mat-chip-row *ngFor="let email of emailList" [aria-description]="'press enter to edit ' + email"
                  class="email-ids ml-16 mt-8 mb-8">
                  <span class="email-label fw-500 mat-body-1">{{email}}</span>
                </mat-chip-row>
                <div class="no-data flex items-center justify-center w-100-percent" *ngIf="emailList?.length === 0">
                  {{'TENANT_FORM.NO_DATA_FOUND' | transloco}}
                </div>
              </mat-chip-set>
            </ng-template>

            <span *ngIf="emailList?.length > limit"
              class="max-limit ml-16 fs-12">{{'TENANT_FORM.ALLOW_MAX_EMAIL_ADDRESS'
              | transloco: {limit: limit} }}</span>
            <span *ngIf="invalidEmail && invalidEmail?.length !== 0 && emailList?.length <= limit"
              class="max-limit ml-16 fs-12 mat-body-1">{{'TENANT_FORM.ENTER_VALID_EMAIL' | transloco}}</span>

          </form>
        </mat-card>
      </div>

  
    </div>
  </div>
</div>